import React from "react";
import { toPng, toJpeg, toSvg } from "html-to-image";

export const downloadToPNG = (htmlToImage, imageName, onSuccess, onError) => {
  return toPng(htmlToImage)
    .then(function (dataUrl) {
      var link = document.createElement("a");
      link.download = `${imageName}.png`;
      link.href = dataUrl;
      link.click();
      if (onSuccess) {
        onSuccess(true);
      }
    })
    .catch(function (error) {
      console.error("oops, something went wrong!", error);
      if (onError) {
        onError(error);
      }
    });
};

export const downloadToJPEG = (
  htmlToImage,
  imageName,
  onSuccess,
  onError,
  getDataonly
) => {
  return toJpeg(htmlToImage)
    .then(function (dataUrl) {
      if (getDataonly) {
        getDataonly(dataUrl);
      } else {
        var link = document.createElement("a");
        link.download = `${imageName}.jpeg`;
        link.href = dataUrl;
        link.click();
        if (onSuccess) {
          onSuccess(true);
        }
      }
    })
    .catch(function (error) {
      console.error("oops, something went wrong!", error);
      if (onError) {
        onError(error);
      }
    });
};

export const downloadToSVG = (
  htmlToImage,
  imageName,
  onSuccess,
  onError,
  getDataonly
) => {
  return toSvg(htmlToImage)
    .then(function (dataUrl) {
      if (getDataonly) {
        getDataonly(dataUrl);
      } else {
        var link = document.createElement("a");
        link.download = `${imageName}.svg`;
        link.href = dataUrl;
        link.click();
        if (onSuccess) {
          onSuccess(true);
        }
      }
    })
    .catch(function (error) {
      console.error("oops, something went wrong!", error);
      if (onError) {
        onError(error);
      }
    });
};
